<template>
  <BreadCrumb PageTitle="Créer un test QCM" />
  <FaireTestQCM />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import FaireTestQCM from "@/components/SupportDeCours/FaireTestQCM.vue";

export default defineComponent({
  name: "FaireTestQCMPage",
  components: {
    BreadCrumb,
    FaireTestQCM,
  },
});
</script>